import React from "react";
import Grid from "@mui/material/Grid";

import labels from "../../../constants/displayFields";
import Input from "../../../components/form/Input";
import InputField from "../../../components/form/InputField";

export default function OriginQuantityField({
  disabled,
  showAvailableQuantity,
  availableQuantityLabel,
  availableQuantityValue,
}) {
  return (
    <Grid container spacing={1.5}>
      <Grid size={{ xs: 12, sm: showAvailableQuantity ? 6 : 12 }}>
        <Input
          type="number"
          name="quantity"
          label={labels.quantity}
          disabled={disabled}
          showNAButton={false}
        />
      </Grid>
      {showAvailableQuantity && (
        <Grid size={{ xs: 12, sm: 6 }}>
          <InputField
            type="number"
            label={availableQuantityLabel}
            value={availableQuantityValue ?? ""}
            disabled
            size="small"
            variant="outlined"
            margin="none"
            InputProps={{ readOnly: true }}
          />
        </Grid>
      )}
    </Grid>
  );
}
